import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CategoryLayer from "../components/CategoryLayer";

const CategoryPage = () => {
  return (
    <>
      <MasterLayout>
        <CategoryLayer />
      </MasterLayout>
    </>
  );
};

export default CategoryPage;
